const generateSecureRandomHex = (bytes = 16) => {
    const array = new Uint8Array(bytes);
    window.crypto.getRandomValues(array);
    return Array.from(array)
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
};
export async function getPublicKey() {
    const timestamp = Date.now();
    const random = generateSecureRandomHex();
    const publicKey = btoa(`-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA${timestamp}${random}\n-----END PUBLIC KEY-----`);
    return publicKey;
}
function extractOsVersion(userAgent) {
    const windowsMatch = /Windows NT (\d+\.\d+)/.exec(userAgent);
    if (windowsMatch?.[1]) {
        if (windowsMatch[1] === '10.0') {
            return '10';
        }
        return windowsMatch[1].split('.')[0] ?? '';
    }
    const iosMatch = /(?:iPhone OS|CPU OS) (\d+(?:_\d+)*)/.exec(userAgent);
    if (iosMatch?.[1]) {
        return iosMatch[1].replaceAll('_', '.');
    }
    const macMatch = /Mac OS X (\d+(?:_\d+)*)/.exec(userAgent);
    if (macMatch?.[1]) {
        return macMatch[1].replaceAll('_', '.');
    }
    const androidMatch = /Android (\d+(?:\.\d+)?)/.exec(userAgent);
    if (androidMatch?.[1]) {
        return androidMatch[1];
    }
    return '';
}
function sanitizeOsVersion(osVersion) {
    return osVersion.replaceAll(/[^\d.]/g, '').slice(0, 24);
}
function detectBrowserName(userAgent) {
    if (userAgent.includes('Edg/')) {
        return 'Edge';
    }
    if (userAgent.includes('OPR/') || userAgent.includes('Opera')) {
        return 'Opera';
    }
    if (userAgent.includes('Chrome')) {
        return 'Chrome';
    }
    if (userAgent.includes('Firefox')) {
        return 'Firefox';
    }
    if (userAgent.includes('Safari')) {
        return 'Safari';
    }
    return 'Unknown';
}
function detectOsName(userAgent) {
    if (userAgent.includes('Windows')) {
        return 'Windows';
    }
    if (userAgent.includes('Mac')) {
        return 'macOS';
    }
    if (userAgent.includes('Linux')) {
        return 'Linux';
    }
    if (userAgent.includes('Android')) {
        return 'Android';
    }
    if (userAgent.includes('iOS')) {
        return 'iOS';
    }
    return 'Unknown';
}
export function getBrowserInfo() {
    const userAgent = navigator.userAgent;
    const browserName = detectBrowserName(userAgent);
    const osName = detectOsName(userAgent);
    const osVersion = sanitizeOsVersion(extractOsVersion(userAgent));
    return { userAgent, browserName, osName, osVersion };
}
